<div class="container p-3">
  <div>
    <h2 class="text-center text-primary">Gestione Aziende B2B</h2>
    <h4 class="text-center pointer" (click)="collapse.toggle()">
      Filtri<i
        class="bi ms-2"
        style="font-size: 16px"
        [ngClass]="isCollapsed ? 'bi-caret-down-fill' : 'bi-caret-up-fill'"
      ></i>
    </h4>
    <form
      class="row m-3 p-3 bg-info rounded"
      [formGroup]="filters"
      #collapse="ngbCollapse"
      [(ngbCollapse)]="isCollapsed"
    >
      <div class="col-6 mb-3">
        <label for="id" class="form-label">Hubspot ID</label>
        <input
          type="string"
          id="id"
          class="form-control"
          formControlName="id"
        />
      </div>
      <div class="col-6 mb-3">
        <label for="vatNumber" class="form-label">Partita IVA</label>
        <input
          type="string"
          id="vatNumber"
          class="form-control"
          formControlName="vatNumber"
        />
      </div>
      <div class="col-6 mb-3">
        <label for="name" class="form-label">Nome</label>
        <input
          type="string"
          id="name"
          class="form-control"
          formControlName="name"
        />
      </div>
      <div class="col-6 mb-3">
        <label for="customerType" class="form-label">Dimensione</label>
        <select
          class="form-select"
          id="size"
          aria-label="Default select example"
          formControlName="size"
        >
          <option [value]="null">Tutte</option>
          <option value="EXTRA_SMALL">1-10 dipendenti</option>
          <option value="SMALL">11-50 dipendenti</option>
          <option value="MEDIUM">51-200 dipendenti</option>
          <option value="LARGE">200+ dipendenti</option>
        </select>
      </div>
      <button
        class="col-3 btn btn-primary m-auto text-light"
        (click)="collapse.toggle(); applyFilters()"
      >
        Applica
      </button>
      <button
        class="col-3 btn btn-secondary m-auto text-light"
        (click)="collapse.toggle(); resetFilters()"
      >
        Reset
      </button>
    </form>

    <div class="d-flex flex-row-reverse gap-2">
      <button class="btn btn-info my-2" (click)="createCompany()">
        <i class="bi bi-plus-square"></i>
      </button>
    </div>
    <table class="fh-table">
      <thead>
        <tr>
          <th scope="col">Hubspot ID</th>
          <th scope="col">Nome</th>
          <th scope="col">Partita IVA</th>
          <th scope="col">Dimensione</th>
          <th scope="col">Inattiva</th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let company of companies">
          <th scope="row">{{ company.id }}</th>
          <td>{{ company.name }}</td>
          <td>{{ company.vatNumber }}</td>
          <td>{{ getCompanySizeLabel(company.size) }}</td>
          <td>{{ company.passive ? "Sì" : "No" }}</td>
          <td>
            <a [routerLink]="['/b2b-companies', company.id]">
              <button class="btn btn-primary px-2 py-1">
                <i class="bi bi-search text-light pointer"></i>
              </button>
            </a>
          </td>
          <td>
            <a (click)="createInviteLink(company.id)">
              <button class="btn btn-primary px-2 py-1">
                <i class="bi bi-share-fill text-light pointer"></i>
              </button>
            </a>
          </td>
          <td>
            <button
              class="btn btn-danger px-2 py-1"
              (click)="deleteCompany(company.id)"
            >
              <i class="bi bi-x-lg text-light pointer"></i>
            </button>
          </td>
        </tr>
        <tr *ngIf="companies.length === 0">
          <td colspan="10" class="text-center">
            Non sono stati trovati servizi.
          </td>
        </tr>
      </tbody>
    </table>
    <div class="row">
      <p class="col">
        Sono presenti <b>{{ collectionSize }}</b> aziende in totale.
      </p>
      <ngb-pagination
        class="col d-flex justify-content-end"
        *ngIf="companies.length > 0"
        [maxSize]="5"
        [(page)]="page"
        [pageSize]="pageSize"
        [collectionSize]="collectionSize"
        (pageChange)="onPageChange()"
      ></ngb-pagination>
    </div>

    <app-alert
      *ngIf="showDeleteConfirm"
      (save)="confirmDelete($event)"
      [data]="{ type: undefined }"
      [title]="'Conferma eliminazione'"
      [message]="
        'Sei sicuro di voler eliminare l\'azienda ' + selectedCompanyId + '?'
      "
    >
    </app-alert>
  </div>
</div>
